module.exports = __webpack_public_path__ + "static/calendar.432d7fd7.png";